var Marionette = require('backbone.marionette');

var PersonsCollection = require('../../collections/persons-collection');
var Person = require('../../models/person-model');
var PersonForm = require('./person-form-view');
var Pager = require('../pager/pager-view.js');

var CommonUtils = require('../../utils/common-utils.js');
var Constants = require('../../utils/constants');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');


var PersonItem = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/persons/person-item.html'),

    ui: {
        checkOrUncheck: '.check-person'
    },

    events: {
        'click .activate': 'activate',
        'click .deactivate': 'deactivate',
        'click @ui.checkOrUncheck': 'checkOrUncheck'
    },

    templateContext: function () {
        var that = this;
        var object = that.model.get('object');
        return {
            formatDate: that.getOption('formatDate'),
            birthDate: (object.birthData == '' || object.birthData == null || object.birthData == 0 ? ''
                : that.utils.longToDateTimeFormattedInUtc(Number(object.birthData), 'MM/DD/YYYY'))
        }
    },

    initialize: function (options) {
        this.utils = new CommonUtils();
    },

    activate: function (event) {
        this.sendActiveRequest(true, $(event.target).attr('uid'));
    },

    deactivate: function (event) {
        this.sendActiveRequest(false, $(event.target).attr('uid'));
    },

    sendActiveRequest: function (status, uid) {
        var that = this;
        var action = status ? 'activate' : 'deactivate';
        $.ajax({
            type: "POST",
            url: '/api/person/' + uid + '/' + action,
            statusCode: {
                200: function () {
                    that.model.set('active', status);
                    that.render();
                }
            }
        });
    },

    checkOrUncheck: function (event) {
        this.triggerMethod('row:selected', {
            personId: this.model.get("id"),
            addOrRemove: event.target.checked
        });
    }
});

var EmptyView = Marionette.View.extend({
    tagName: 'tr',
    template: _.template(_.reduce(_.map(_.range(8), function (value) {
        return '<td>-</td>'
    }), function (memo, str) {
        return memo + str;
    }, ""))
});


var PersonsTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: PersonItem,
    emptyView: EmptyView,

    collectionEvents: {
        request: 'showLoading',
        sync: 'hideLoading',
        error: 'logError'
    },

    childViewEvents: {
        'row:selected': 'onPersonRowSelected'
    },

    initialize: function (options) {
        _.bindAll(this, 'showLoading', 'hideLoading', 'logError');
        this.collection = options.collection;
        this.formatDate = options.formatDate;
    },

    childViewOptions: function () {
        return {formatDate: this.formatDate};
    },

    showLoading: function () {
        this.$('.loading').show();
    },

    hideLoading: function () {
        this.$('.loading').hide();
    },

    logError: function (obj, response) {
        this.$('.loading').hide();
        this.triggerMethod('server:error', response.responseText);
    },

    onPersonRowSelected: function (data) {
        this.triggerMethod('row:selected', data);
    }
});

var PersonsList = Marionette.View.extend({
    template: require('../../templates/persons/persons.html'),

    regions: {
        modal: '#addPersonModal',
        form: '#form',
        tableBody: {
            el: 'tbody',
            replaceElement: true
        },
        pager: '#pager'
    },

    ui: {
        saveBtn: '#save-person',
        filterBtn: '#filter',
        resetBtn: '#reset',
        filterField: '.filter-field',
        burnAfter: '#burn-after',
        burnBefore: '#burn-before',
        checkOrUncheckAll: '#check-all'
    },

    events: {
        'click @ui.saveBtn': 'savePerson',
        'click @ui.filterBtn': 'applyFilter',
        'click @ui.resetBtn': 'resetFilter',
        'click @ui.checkOrUncheckAll': 'checkOrUncheckAllPersons'
    },

    collectionEvents: {
        error: 'logError'
    },

    childViewEvents: {
        'person:save:valid': 'savePersonBtnEnableOrDisable',
        'row:selected': 'onPersonRowSelected'
    },

    templateContext: function () {
        var that = this;
        return {
            getParam: function (key) {
                return that.params[key];
            },
            getDateParam: function (key) {
                if (that.params[key]) {
                    try {
                        return that.utils.longToDateTimeFormatted(Number(that.params[key]), 'MM/DD/YYYY');
                    } catch (e) {
                        console.log(e);
                        return undefined;
                    }
                }
                return undefined;
            }
        }
    },

    initialize: function (options) {
        this.model = new Person();
        this.utils = new CommonUtils();
        this.params = $.deparam(window.location.hash.replace('#persons', '').replace('?', ''));
        this.defaultListParams = this.utils.getDefaultListParams();
        this.personsIds = [];
        this.initDefaultCollectionParams()
    },

    initDefaultCollectionParams: function () {

        this.defaultCollectionParams = [
            {key: 'active', value: 'true'},
            {key: 'active', value: 'false'},
            {key: 'sortby', value: 'createdTime'},
            {key: 'sortdir', value: 'DESC'},
            {key: 'page-size', value: Constants.pageCapacity}
        ]
    },

    onErrors: function (model, errors) {
        model.view.triggerMethod('server:error', errors.join('. \n'));
    },

    onRender: function () {
        window.document.title = "RNS Persons";
        var that = this;
        that.personForm = new PersonForm({model: that.model, isEditMode: false});
        that.showChildView('form', that.personForm);

        that.collection = new PersonsCollection([],
            {params: that.utils.mergeCollectionParams(that.defaultCollectionParams, that.utils.queryParamsToCollection(that.params) || [])});

        that.showLoading();
        that.collection.fetch({
            success: function () {
                that.renderTable();

                that.showChildView('pager', new Pager({
                    baseCountUrl: '/api/person/count?active=true&active=false'
                }));
                that.hideLoading();
            },
            error: function () {
                that.hideLoading();
            }
        });

        that.ui.burnAfter.datepicker({
            format: 'mm/dd/yyyy',
            clearBtn: true
        }).on('changeDate', function (e) {
            $(this).datepicker('hide');
        });
        that.ui.burnBefore.datepicker({
            format: 'mm/dd/yyyy',
            clearBtn: true
        }).on('changeDate', function (e) {
            $(this).datepicker('hide');
        });

        if (that.utils.isUrlWoExtraQueryParameters()) {
            that.ui.resetBtn.hide();
        } else {
            that.ui.resetBtn.show();
        }
    },

    renderTable: function () {
        var that = this;
        that.showChildView('tableBody', new PersonsTableBody({
            collection: new PersonsCollection(that.collection.filter(function (model) {
                return model.get("object").login != "undefined" && model.get("object").login != "null";
            })), formatDate: function (dateAsLong) {
                return that.utils.longToDateTimeFormatted(dateAsLong, 'MMM DD YYYY');
            }
        }));
    },

    savePerson: function () {
        var that = this;
        this.model = this.personForm.fillModel();
        this.model.save(this.model.toJSON(), {
            success: function (response) {
                $('#addPersonModal').modal('hide');
                that.itemSaved();
            },
            error: function (model, xhr, options) {
                notificationsChannel.request('show:notification', JSON.parse(xhr.responseText));
                that.personForm.validateAllRequiredFields();
            }
        });
    },

    itemSaved: function () {
        this.resetFilter();
    },

    showLoading: function () {
        this.$('.loading').show();
    },

    hideLoading: function () {
        this.$('.loading').hide();
    },

    logError: function (obj, response) {
        this.$('.loading').hide();
        this.triggerMethod('server:error', response.responseText);
    },

    savePersonBtnEnableOrDisable: function (data) {
        if (data.result)
            this.ui.saveBtn.removeAttr("disabled");
        else
            this.ui.saveBtn.attr("disabled", "true");
    },

    applyFilter: function () {
        var that = this;

        that.ui.filterField.each(function (i, element) {
            if ($(element).attr('name')) {
                var name = $(element).attr('name');
                if ($(element).val()) {
                    that.defaultListParams[name] = $(element).val();
                } else {
                    delete that.defaultListParams[name];
                }
            }
        });

        if (that.ui.burnAfter.val() != undefined && that.ui.burnAfter.val() != '')
            that.defaultListParams['object_birthData_from'] = that.utils.dateToLong(that.ui.burnAfter.val());
        else
            delete (that.defaultListParams['object_birthData_from']);

        if (that.ui.burnBefore.val() != undefined && that.ui.burnBefore.val() != '')
            that.defaultListParams['object_birthData_to'] = that.utils.dateToLong(that.ui.burnBefore.val());
        else
            delete (that.defaultListParams['object_birthData_to']);

        that.defaultListParams.page = 0;
        window.location.hash = that.utils.getCleanBaseHash() + "?" + that.utils.objectToQueryParams(that.defaultListParams);
    },

    resetFilter: function () {
        this.utils.redirectToUrlWoExtraQueryParameters();
    },

    checkOrUncheckAllPersons: function (event) {
        var that = this;
        if (event.target.checked) {
            $('.check-person').prop('checked', true);

            that.personsIds = that.collection.map(function (model) {
                return model.get('id');
            });
        } else {
            that.personsIds = [];
            $('.check-person').prop('checked', false);
        }

        that.personsIds = _.uniq(that.personsIds);
        console.log(that.personsIds);
    },

    onPersonRowSelected: function (data) {
        var that = this;
        if (data.addOrRemove) {
            that.personsIds.push(data.personId);
        } else {
            that.personsIds = (that.personsIds || []).filter(function (id) {
                return id !== data.personId
            });
        }

        that.personsIds = _.uniq(that.personsIds);
        console.log(that.personsIds);
    }
});


module.exports = PersonsList;


//////////////////
// WEBPACK FOOTER
// ./app/views/persons/persons-view.js
// module id = 335
// module chunks = 0